<template>
  <div id="menus-carta">
    <div id="customMenu" class="language-control-menu" v-if="params.languageMenuActivate"  style="cursor: pointer; ">
      <div v-if="getAvailableLang('spanish')" @click="setTypeLanguageMenu('spanish')" style="margin-right: 5px;" :style="{fontWeight: (multiLanguage === 'spanish') ? '600' : 'unset'}">ES</div>
      <div v-if="(getAvailableLang('spanish') && getAvailableLang('french')) || (getAvailableLang('spanish') && getAvailableLang('english'))">/</div>
      <div v-if="getAvailableLang('english')" @click="setTypeLanguageMenu('english')" style="margin-left: 5px;" :style="{ fontWeight: (multiLanguage === 'english') ? '600' : 'unset', marginRight: (getAvailableLang('french')) ? '5px' : null }">EN</div>
      <div v-if="(getAvailableLang('english') && getAvailableLang('french') && getAvailableLang('spanish')) || (getAvailableLang('english') && getAvailableLang('french') && !getAvailableLang('spanish'))" >/</div>
      <div v-if="getAvailableLang('french')" @click="setTypeLanguageMenu('french')" style="margin-left: 5px;" :style="{fontWeight: (multiLanguage === 'french') ? '600' : 'unset'}">FR</div>
    </div>
    <b-loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></b-loading>
    <div :key="'menu' + index" class v-for="(menuItem, index) in menu">
      <div class v-if="menuItem.type === 'image' && menuItem.typeLanguage === multiLanguage && menuItem.isActive === 1">
        <a :href="menuItem.imageExternalUrl" target="_blank" v-if="menuItem.activeUrlImage === 1">
          <img :src="menuItem.image" alt="img menu" class="image-carta" />
        </a>
        <img :src="menuItem.image" alt="img menu" class="image-carta" v-else />
        <button
          @click="sendWhatsapp"
          id="whatsapp"
          title="Escribir por Whatsapp"
          v-if="params.whatsappNumber !== null"
        >
          <i class="fa fa-whatsapp" style="color: #ffffff; font-size: 30px"></i>
        </button>
      </div>
      <div class="menu-custom-select" v-else-if="menuItem.type === 'custom'">
        <CustomMenu :menuId="menuItem.vendorCustomId" :typeLanguage="multiLanguage"></CustomMenu>
      </div>
    </div>
    <div class="image_tips" v-if="vendor.id == 329 || vendor.id == 327">
      <img
        :alt="vendor.displayName"
        src="@/assets/images/menuDigital/tip_warning_en.png"
        v-if="multiLanguage == 'english'"
      />
      <img :alt="vendor.displayName" src="@/assets/images/menuDigital/tip_warning_es.png" v-else />
    </div>
    <div
      class="image_tips"
      v-if="params.activeSecondFooterCreeps == 1 && vendor.id != 329 && vendor.id != 327"
    >
      <img
        :alt="vendor.displayName"
        src="@/assets/images/menuDigital/tip_warning_en.png"
        v-if="multiLanguage == 'english'"
      />
      <img :alt="vendor.displayName" src="@/assets/images/menuDigital/tip_warning_es.png" v-else />
    </div>
    <div
      :style="'background:white; overflow: hidden; margin-top: -2px; padding-bottom: unset;'"
      class="footer-menu dinamic-height"
      v-if="params.activeSecondFooterCreeps == 1"
    >
      <img
        :alt="vendor.displayName"
        :style="'max-width: 300%;'"
        src="@/assets/images/menuDigital/Hipoconsumo-08.png"
        style="margin: 15px 0"
      />
    </div>
  </div>
</template>
<script>
import CustomMenu from './customMenu.vue';
import { metrics } from '@/helpers/apis/metrics.js';
import globalTypes from '@/store/types/global';

export default {
  components: { CustomMenu },
  props: ['menu'],
  data () {
    return {
      loading: false
    };
  },
  created () {
    this.loading = true;
    if (this.menu.length > 0) {
      if (this.menu[0].type === 'url') {
        window.location.href = this.menu[0].imageExternalUrl;
      } else {
        this.loading = false;
      }
    } else {
      this.loading = false;
    }
  },
  mounted () {
    if (this.params.languageMenuActivate && this.params.availableLanguages) {
      const orderLangs = this.params.availableLanguages.split(',').sort((a, b) => {
        const order = { spanish: 1, english: 2, french: 3 };
        return (order[a] || 0) - (order[b] || 0);
      });
      if (this.multiLanguage !== orderLangs[0]) {
        this.$store.commit(globalTypes.mutations.setMultiLanguage, this.multiLanguage);
      } else {
        this.$store.commit(globalTypes.mutations.setMultiLanguage, orderLangs[0]);
      }
    }
    if (this.params.bannerActiveMenuDigital === 1) {
      this.$store.commit('whiteLabel:setMenuIdBanner', this.menu[0].menuId);
    }
    this.sendMetrics();
  },
  computed: {
    getAvailableLang () {
      return (value) => {
        const arrayLangs = this.params.availableLanguages.split(',');
        if (arrayLangs.find(lang => lang === value)) {
          return true;
        }
        return false;
      };
    }
  },
  methods: {
    sendWhatsapp () {
      if (this.$isMobile()) {
        window.open(
          'https://api.whatsapp.com/send?phone=' +
          this.params.whatsappNumber +
          '&text=hola',
          '_blank'
        );
      } else {
        window.open(
          'https://web.whatsapp.com/send?phone=' +
          this.params.whatsappNumber +
          '&text=hola',
          '_blank'
        );
      }
    },
    setTypeLanguageMenu (type) {
      this.$store.commit(globalTypes.mutations.setMultiLanguage, type);
    },
    sendMetrics () {
      this.menu.map(item => {
        if (item.typeLanguage === this.multiLanguage) {
          metrics('multimenu-item', this.multiLanguage, item.id);
        }
      });
    }
  }
};
</script>
<style lang="scss">
#menus-carta {
  .dinamic-height {
    height: 20px !important;
  }
  .image_tips {
    margin-top: -6px;
    img {
      width: 100%;
    }
  }
  overflow: auto;
  -webkit-overflow-scrolling: auto;
  height: 100%;
  .image-carta {
    width: 100%;
    height: auto;
  }
  .menu-custom-select {
    width: 100%;
    height: auto;
  }
  #whatsapp {
    position: fixed; /* Fixed/sticky position */
    bottom: 70px; /* Place the button at the bottom of the page */
    right: 15px; /* Place the button 30px from the right */
    border: none; /* Remove borders */
    outline: none; /* Remove outline */
    background-color: var(--buttonBackground); /* Set a background color */
    color: var(--buttonTextColor); /* Text color */
    cursor: pointer; /* Add a mouse pointer on hover */
    padding: 10px; /* Some padding */
    border-radius: 10px; /* Rounded corners */
    font-size: 18px; /* Increase font size */
    z-index: 999;
    box-shadow: none;
    background: rgb(37, 211, 102);
  }
  @media (max-width: 1599px) and (min-width: 650px) {
    .dinamic-height {
      height: 40px !important;
    }
  }
  @media (max-width: 2500px) and (min-width: 1600px) {
    .dinamic-height {
      height: 75px !important;
    }
  }
}
</style>
